export enum PatchUploadStatus {
    UploadInitiated = "UPLOAD_INIT",
    UploadStarted = "UPLOAD_START",
    UploadInProgress = "UPLOAD_PROGRESS",
    UploadCompleted = "UPLOAD_COMPLETE",
    UploadFailed = "UPLOAD_FAILED",
    UploadTimout = "UPLOAD_TIMEOUT",
    UploadCancelled = "UPLOAD_CANCEL"
}
export enum PatchUploadErrors {
    Aborted = "AbortError",
    GeneralError = "GeneralError",
    NetworkError="NetWorkError",
    TimedOut = "TimeOut"
}

